var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.825 1.78705C13.059 0.717708 14.5817 0.711052 14.8251 1.77831L14.8361 1.82699C14.8434 1.85987 14.8505 1.89014 14.8578 1.92172C15.1231 3.05147 16.0375 3.91471 17.1819 4.11382C18.2979 4.30798 18.2979 5.91009 17.1819 6.10425C16.0313 6.30442 15.1134 7.17582 14.8536 8.31446L14.8251 8.43976C14.5817 9.50703 13.059 9.50036 12.825 8.43103L12.8015 8.32351C12.5513 7.18079 11.6347 6.30298 10.4822 6.10248C9.36818 5.90866 9.36817 4.30941 10.4822 4.1156C11.6307 3.9158 12.5449 3.04339 12.7988 1.90651L12.8161 1.82768L12.825 1.78705ZM1.28002 1.05253C0.573088 1.05253 0 1.62562 0 2.33256V7.77267C0 8.47961 0.573088 9.05269 1.28002 9.05269H6.72015C7.42709 9.05269 8.00017 8.47961 8.00017 7.77267V2.33256C8.00017 1.62562 7.42709 1.05253 6.72015 1.05253H1.28002ZM0 12.2803C0 11.5733 0.573088 11.0002 1.28002 11.0002H6.72015C7.42709 11.0002 8.00017 11.5733 8.00017 12.2803V17.7204C8.00017 18.4274 7.42709 19.0004 6.72015 19.0004H1.28002C0.573088 19.0004 0 18.4274 0 17.7204V12.2803ZM9.94771 12.2803C9.94771 11.5733 10.5208 11.0002 11.2277 11.0002H16.6678C17.3748 11.0002 17.9479 11.5733 17.9479 12.2803V17.7204C17.9479 18.4274 17.3748 19.0004 16.6678 19.0004H11.2277C10.5208 19.0004 9.94771 18.4274 9.94771 17.7204V12.2803Z",
    fill: "url(#paint0_linear_708_1604)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_708_1604",
    x1: 0,
    y1: 19.0004,
    x2: 4.45989,
    y2: -1.91044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD90EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BDD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainColor);
export default __webpack_public_path__ + "static/media/mainColor.ba147db8e18368b2128aff9c5f067de8.svg";
export { ForwardRef as ReactComponent };